import React                from "react";
import PropTypes            from "prop-types";
import Store                from "Dashboard/Core/Store";
import useForm              from "Dashboard/Hooks/Form";
import useDialog            from "Dashboard/Hooks/Dialog";

// Dashboard
import EditDialog           from "Dashboard/Components/Dialogs/EditDialog";
import InputField           from "Dashboard/Components/Form/InputField";



/**
 * The Category Edit Dialog
 * @param {Object} props
 * @returns {React.ReactElement}
 */
function CategoryEdit(props) {
    const { open, elemID, onClose, onSubmit } = props;

    const { activities, statuses } = Store.useState("newsCategory");
    const { editElem } = Store.useAction("newsCategory");


    // The Initial Data
    const initialData = {
        newsCategoryID : 0,
        activityID     : 0,
        name           : "",
        isDefault      : 0,
        status         : "Active",
        position       : 0,
    };

    // The Form State
    const {
        data, errors, setElem, handleChange, handleSubmit,
    } = useForm("newsCategory", initialData, editElem, onSubmit);

    // Load the Data
    const { loading } = useDialog("newsCategory", open, elemID, {}, setElem);


    // Do the Render
    return <EditDialog
        open={open}
        icon="category"
        title={elemID ? "CATEGORIES_EDIT_TITLE" : "CATEGORIES_CREATE_TITLE"}
        error={errors.form}
        onSubmit={handleSubmit}
        onClose={onClose}
        isLoading={loading}
        isNarrow
    >
        <InputField
            name="name"
            label="GENERAL_NAME"
            value={data.name}
            error={errors.name}
            onChange={handleChange}
            isRequired
        />
        <InputField
            type="select"
            name="activityID"
            label="ACTIVITIES_SINGULAR"
            options={activities}
            value={data.activityID}
            error={errors.activityID}
            onChange={handleChange}
        />
        <InputField
            type="toggle"
            name="isDefault"
            label="GENERAL_IS_DEFAULT"
            value={data.isDefault}
            onChange={handleChange}
            withBorder
        />
        <InputField
            type="select"
            name="status"
            label="GENERAL_STATUS"
            options={statuses}
            value={data.status}
            error={errors.status}
            onChange={handleChange}
            hideClear
            isRequired
        />
        <InputField
            type="number"
            name="position"
            label="GENERAL_POSITION"
            value={data.position}
            error={errors.position}
            onChange={handleChange}
            minValue={0}
        />
    </EditDialog>;
}

/**
 * The Property Types
 * @typedef {Object} propTypes
 */
CategoryEdit.propTypes = {
    open     : PropTypes.bool.isRequired,
    onClose  : PropTypes.func.isRequired,
    onSubmit : PropTypes.func.isRequired,
    elemID   : PropTypes.number,
};

export default CategoryEdit;
